export enum QuarrySortByColumns {
  QUARRY_NAME = "quarryName",
  LOCATION = "location",
  TYPE = "type",
  ACCOUNT_LIMIT = "accountLimit",
  CURRENT_BALANCE = "currentBalance",
  OVERDUE_BALANCE = "overdueBalance",
  LIFETIME_PURCHASES = "lifeTimePurchases",
  LAST_3_MONTHS = "last3Months",
  LAST_30_DAYS = "last30Days",
}
